
import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
    auth: {
        clientId: import.meta.env.VITE_MSAL_CLIENT_ID || "7216bf27-8b1a-4240-b67f-b74fb693546e",
        authority: import.meta.env.VITE_MSAL_AUTHORITY || "https://login.microsoftonline.com/b95b17f0-2f7d-4d21-99f8-c0d383a1e5cd",
        redirectUri: import.meta.env.VITE_MSAL_REDIRECT_URI || "http://localhost:3000/"
    },
    cache: {
        cacheLocation: "sessionStorage", 
        storeAuthStateInCookie: false, 
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii || !import.meta.env.DEV) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};

/**
 * Escopo do token para a API (spec 20261019-gestao-de-acessos, RNF04).
 *
 * Vazio enquanto o app registration do Entra ID não expõe `api://<client id>/access_as_user`:
 * o `apiFetch` não pede token e o login fica como sempre foi. Definido, o login já pede o
 * consentimento para a API e cada chamada leva o token. Pedir um escopo que ainda não existe
 * faria o login falhar para todo mundo — por isso ele não tem valor padrão.
 */
export const apiScope = (import.meta.env.VITE_MSAL_API_SCOPE || '').trim();

export const loginRequest = {
    scopes: ["User.Read"],
    ...(apiScope ? { extraScopesToConsent: [apiScope] } : {}),
}; 